import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory, useParams } from 'react-router';
import Button from '../../shared/Button';
import Header from './Header';
import ChannelSetting from './ChannelSetting';
import SyncUserInfo from './SyncUserInfo';

const useStyles = makeStyles(
  {
    root: {},
  },
  {
    name: 'Step1Container',
  },
);

const Step1Container = ({ provider }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const { orgId } = useParams();

  const handleNext = () => {
    history.push(`/${provider}/${orgId}/step2`);
  };

  return (
    <div className={classes.root}>
      <Header />
      <ChannelSetting provider={provider} />
      <SyncUserInfo />
      <Button topic="primaryGreen" onClick={handleNext}>
        {t('next')}
      </Button>
    </div>
  );
};

export default Step1Container;
